module.exports = __webpack_public_path__ + "img/sac-sidebar-ipad.b7c8d4c2.png";